import React, { useState, useEffect, useMemo } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

// Use legacy build from unpkg CDN - works in production
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;

// Detect if device is iOS
const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || 
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

const PDFViewer = () => {
  const [numPages, setNumPages] = useState(null);
  const [pageWidth, setPageWidth] = useState(window.innerWidth);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setPageWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setLoading(false);
  };

  const onDocumentLoadError = (error) => {
    console.error('PDF Load Error:', error);
    setError(error);
    setLoading(false);
  };

  // Memoize options to prevent unnecessary reloads
  const options = useMemo(() => ({
    cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
    cMapPacked: true,
  }), []);

  // For iOS devices, use native PDF viewer as fallback if react-pdf fails
  if (isIOS() && error) {
    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src="/KINC_BIOCARE_Brochure.pdf"
          style={{ width: "100%", height: "100%", border: "none" }}
          title="KINC BIOCARE Brochure"
        />
      </div>
    );
  }

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "auto", backgroundColor: "#f0f0f0" }}>
      {loading && (
        <div style={{ 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center", 
          height: "100vh",
          fontSize: "18px"
        }}>
          Loading PDF...
        </div>
      )}
      <Document
        file="/KINC_BIOCARE_Brochure.pdf"
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
        loading={null}
        options={options}
      >
        {numPages && Array.from(new Array(numPages), (el, index) => (
          <Page 
            key={`page_${index + 1}`} 
            pageNumber={index + 1} 
            width={pageWidth}
            renderTextLayer={true}
            renderAnnotationLayer={true}
          />
        ))}
      </Document>
    </div>
  );
};

const RoutesComponents = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PDFViewer />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RoutesComponents;
